import React from 'react';
import ProjectCard from './ProjectCard';
import { Project } from '../../store/slices/projectsSlice';
import LoadingSpinner from '../UI/LoadingSpinner';

interface ProjectGridProps {
  projects: Project[];
  isLoading?: boolean;
}

const ProjectGrid: React.FC<ProjectGridProps> = ({ projects, isLoading }) => {
  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <LoadingSpinner size="lg" text="Loading projects..." />
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-[var(--color-subtext-color)] text-lg">No projects found</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
      {projects.map((project) => (
        <ProjectCard key={project._id} project={project} />
      ))}
    </div>
  );
};

export default ProjectGrid;

